/** 
*@author: satyamurthy.a
*@Description : 
**/
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { RBSLOOKUPMaster } from '../../../../commons/api';
import { getList,  deleteById } from './Utils/FormCalls';
import { message, Input, Button, Tooltip, Popconfirm } from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
import StyledTable from '../../../../commons/styles/table';

const APIList = {
  getLookupMasterList: `${RBSLOOKUPMaster.GET}`,
  getLookupMasterById: `${RBSLOOKUPMaster.GetById}`,
  insertLookupMaster: `${RBSLOOKUPMaster.CREATE}`,
  deleteLookupMaster: `${RBSLOOKUPMaster.Delete}`
};

const LookupMasters = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  useEffect(() => {
    getLookupMasterList();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation('Search') + translation(dataIndex)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          {translation('Search')}
        </Button>
        <Button
          type='primary'
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };

  const getLookupMasterList = async () => {
    let lookupMasterList = await getList(APIList.getLookupMasterList);
    setDataSource(lookupMasterList && Array.isArray(lookupMasterList) ? [...lookupMasterList] : []);
  };

  const _deleteById = async (Id) => {
    let response = await deleteById(APIList.deleteLookupMaster, Id, 'LookupId');
    response && response.message && message.success(response.message);
    getLookupMasterList();
  };

  // const handleSave = async (values) => {
  //   let response = await insert(APIList.insertLookupMaster, values);
  //   getLookupMasterList();
  //   return (
  //     <Alert
  //       message={response && response.message ? response.message : ''}
  //       type="success"
  //       showIcon
  //       closable
  //     />
  //   );
  // };

  // const handleAdd = () => {
  //   const newData = {
  //     key: dataSource.length + 1,
  //     Lookup_Name: '',
  //     Description: '',
  //     enabled: ''
  //   };
  //   setDataSource([...dataSource, newData]);
  // };

  const addNew = () => {
    props.navigate('/rubus/LookupMasterItemDetails/new');
  };

  const columns = [
    {
      title: translation('Lookup Code'),
      key: 'LookupName',
      dataIndex: 'LookupName',
      editable: true,
      disable: true,
      filterMode: 'tree',
      filterSearch: true,
      ...getColumnSearchProps('LookupName'),
      sorter: (a, b) =>
        a.LookupName && b.LookupName ? a.LookupName.localeCompare(b.LookupName) : null
    },
    {
      title: translation('Description'),
      key: 'Description',
      dataIndex: 'Description',
      editable: true
    },
    {
      title: translation('Enabled'),
      key: 'Enabled',
      dataIndex: 'Enabled',
      editable: true,
      ...getColumnSearchProps('Enabled'),
      sorter: (a, b) => String(a.Enabled).localeCompare(String(b.Enabled)),
      render: (text) => String(text)
    },
    {
      title: translation('Created By'),
      key: 'CreatedName',
      dataIndex: 'CreatedName',
      ...getColumnSearchProps('CreatedName'),
      sorter: (a, b) =>
        a.CreatedName && b.CreatedName && a.CreatedName.localeCompare(b.CreatedName)
    },
    {
      title: translation('Created Date'),
      key: 'CreatedTime',
      dataIndex: 'CreatedTime',
      ...getColumnSearchProps('CreatedTime'),
      sorter: (a, b) =>
        new Date(moment(a.CreatedTime, 'YYYY-MM-DD HH:mm:ss').format('LLL')) -
        new Date(moment(b.CreatedTime, 'YYYY-MM-DD HH:mm:ss').format('LLL')),
      render: (text) => (
        <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
      )
    },
    {
      title: translation('Action'),
      width: '600',
      render: (text, record) => (
        <>
          <Tooltip title={translation('Edit')}>
            <Button
              type='primary'
              data-testid={'lift-hold-button'}
              disabled={record.Status === 'Inactive'}
              style={{ marginRight: '5px' }}
              onClick={() => props.navigate(`/rubus/LookupMasterItemDetails/${record.LookupId}`)}
              
            >
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title={translation('Are you sure ?,If you delete lookup code it will delete all the corresponding lookupitems')}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.LookupId)}
            okText={translation('Yes')}
            cancelText={translation('No')}
          >
            <Tooltip title={translation('Delete')}>
              <Button type='primary' >
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Button
          onClick={addNew}
          type="primary"
          style={{ marginBottom: 16 }}
        >
          {translation('Add')}
        </Button>
      </div>
      <StyledTable size="small"
        dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
        columns={columns}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(LookupMasters);